import PropTypes from 'prop-types';
import React from 'react';

import Table from '@appComponents/Table';

import {columns} from './eventWatermarkingTableColumns';
import {rowRenderer} from './eventWatermarkingTableRowRenderer';
import {getWatermarkingRowClassname} from './eventWatermarkingTableHelper';

const EventWatermarkingTable = ({eventContentWatermarkings, eventId, loading}) => (
    <div className='eventWatermarking__table'>
        <Table
            className='mini'
            columns={columns}
            data={eventContentWatermarkings}
            defaultSort={(row) => row.event_content.view_name}
            loading={loading}
            name='eventWatermarkingList'
            noDataText='No watermarking configurations found'
            pagination={false}
            rowClassname={getWatermarkingRowClassname}
            rowRenderer={(column, row) => rowRenderer(column, row, eventId)}
        />
    </div>
);

EventWatermarkingTable.propTypes = {
    eventContentWatermarkings: PropTypes.arrayOf(PropTypes.shape({
        event_content: PropTypes.shape({
            view_name: PropTypes.string,
            event_content_variant: PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
                short_name: PropTypes.string,
            }),
        }),
    })),
    eventId: PropTypes.number,
    loading: PropTypes.bool,
};

EventWatermarkingTable.defaultProps = {
    eventContentWatermarkings: [],
    loading: false,
};

EventWatermarkingTable.displayName = 'EventWatermarkingTable';

export default EventWatermarkingTable;
